import React, { useState } from 'react'
import './link-account-section.scss'
import SignInForm from '../signin-form/signin-form'
import LinkedAccounts from '../linked-accounts/linked-accounts'

export const LinkAccountsSec = () => {
  const [pageRefresh, setPageRefresh] = useState(false)

  return (
    <section className="link-account-section">
      <SignInForm
        linkAccountView={true}
        customCss={'otpform-custom-css'}
        setPageRefresh={setPageRefresh}
      />
      <hr className="link-divider divider" />
      <LinkedAccounts pageRefresh={pageRefresh} />
    </section>
  )
}

export default LinkAccountsSec
